import StatusTracking from '@/components/StatusTracking';
import { Card } from '@/globalComponents/card';
import { DividerLine } from '@/globalComponents/dividerLine';
import ImageWithFallback from '@/globalComponents/image';
import AlertIcon from '../../../../../public/images/alertModal/alertIcon.svg';
import styles from './style.module.scss';
import { convertTimeStamp } from './utils';

export type AMCServiceDetailsItemType = {
  display_order: number;
  details: {
    status: boolean;
    desc: string;
    timestamp: string;
  };
};

interface AMCServiceDetailsProps {
  data: AMCServiceDetailsItemType[];
  isError: boolean;
  statusOfDevice: string;
}

export const AMCServiceDetails = (props: AMCServiceDetailsProps) => {
  const { data, isError, statusOfDevice } = props;
  const headerText =
    statusOfDevice === 'warranty' ? 'Warranty Service Details' : 'AMC Service Details';

  const constructStatusTrackingArray = () => {
    return data.map((item) => {
      const {
        details: { status, desc, timestamp },
      } = item;
      return {
        status: status,
        label: (
          <div
            className="flex flex-col md:gap-[2px] gap-s2"
            data-testid="service-details-container"
          >
            <p className={styles.serviceStatusDesc} data-testid="service-description">
              {desc}
            </p>
            <p className={styles.serviceTimeStamp} data-testid="service-date-label">
              {`Service date `}
              <span className={styles.serviceDate} data-testid="service-timestamp">
                {convertTimeStamp(timestamp, status)}
              </span>
            </p>
          </div>
        ),
      };
    });
  };

  if (isError) {
    return (
      <Card
        classNames={`${styles.serviceDetailsContainer} md:h-[477px] h-[272px] inline-grid`}
        data-testid="service-details-error-container"
      >
        <p className={styles.serviceDetailsTitle} data-testid="service-details-title">
          {headerText}
        </p>
        <div className="flex flex-col items-center gap-5">
          <ImageWithFallback data-testid="alert-icon" src={AlertIcon} alt={'Alert Icon'} />
          <p className="font-normal text-lg leading-6 text-[#4F4F4F]" data-testid="error-label">
            Something Went Wrong
          </p>
        </div>
      </Card>
    );
  }

  const shouldShowStatusTracking = data && data.length > 0;

  if (!shouldShowStatusTracking) {
    return <></>;
  }

  const statusTrackingArray = constructStatusTrackingArray();
  const totalServices: number = statusTrackingArray.length;
  const completedServices: number = statusTrackingArray.filter((item) => item.status).length;

  return (
    <Card classNames={styles.serviceDetailsContainer} data-testid="service-details-container">
      <p className={styles.serviceDetailsTitle} data-testid="service-details-title">
        {headerText}
      </p>
      <p className={styles.serviceDetailsLabel} data-testid="service-details-label">
        <span className={styles.serviceDetailsCount} data-testid="count-of-service">
          {`${completedServices}/${totalServices} `}
        </span>
        Service visits for maintenance
      </p>
      <DividerLine
        variant="solid"
        orientation={'horizontal'}
        classNames="border-[#F7F8F9] md:hidden block mt-[14px] md:mt-0"
      />
      <div className="md:mt-6 mt-5">
        <StatusTracking details={statusTrackingArray} classNames="items-center" />
      </div>
    </Card>
  );
};
